// Alle / Base / Soft on the catalogue (main-collection-product-grid):
// picking a line hides the other lines' groups in place — no scrolling to
// an anchor — and "Alle" shows every group again.
//
// The choice lives in ?line=… so a filtered catalogue can be linked to (the
// homepage's "Vælg din model" cards do) and survives a reload. It's written
// with replaceState, so trying the filters doesn't pile up Back-button steps.
// Without JS every group simply shows.
(function () {
  var root = document.querySelector('[data-line-filter]');
  if (!root) return;
  var buttons = [].slice.call(root.querySelectorAll('[data-line]'));
  var groups = [].slice.call(document.querySelectorAll('.line-group[data-line]'));

  function apply(line) {
    var known = buttons.some(function (b) {
      return b.dataset.line === line;
    });
    if (!known) line = 'all';

    buttons.forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.line === line));
    });
    groups.forEach(function (g) {
      g.hidden = line !== 'all' && g.dataset.line !== line;
    });

    var url = new URL(window.location.href);
    if (line === 'all') url.searchParams.delete('line');
    else url.searchParams.set('line', line);
    window.history.replaceState(window.history.state, '', url);
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () {
      apply(b.dataset.line);
    });
  });

  apply(new URLSearchParams(window.location.search).get('line') || 'all');
})();
